import ApiInfo from './ApiInfo.js';

class QuKanPermApiInfo extends ApiInfo {
    constructor ({
        path,
        type = 'get',
        timeout = 5000,
        headers,
        project = 'perm', // || qukan,
        author = '未定义'
    }) {
        super({
            path,
            type,
            timeout,
            headers,
            project,
            author
        });
    }
}

export default {
    member: {
        checkPerm: new QuKanPermApiInfo({
            path: '/member/checkPerm',
            type: 'post',
            author: '刘彪'
        })
    },
    perm: {
        list: new QuKanPermApiInfo({
            path: '/perm/getPermGroupList',
            type: 'post',
            author: '刘彪'
        })
    }
};
